<template>
    <nav class="flex flex-wrap items-center justify-between fixed top-0 z-40 w-full backdrop-blur shadow-sm dark:bg-black p-2 bg-white">        
        <Logo />
        <div>
            <UTooltip text="Alternar modo escuro/claro">
                <UButton :icon="!isDark ? 'i-heroicons-moon-20-solid' : 'i-heroicons-sun-20-solid'" variant="ghost" aria-label="Theme" @click="isDark = !isDark" />
            </UTooltip>
            <UTooltip text="Novidades" class="hidden ">
                <UButton id="beamerBt" icon="i-heroicons-newspaper" variant="ghost"/>
            </UTooltip>
        </div>
    </nav>
    <div class="container mx-auto max-w-md">
        <div class="grid h-screen place-items-center">
            <div class="w-full mx-auto px-12">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup>
const colorMode = useColorMode();

const isDark = computed({
    get() {
        return colorMode.value === 'dark'
    },
    set() {
        colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
    }
})
</script>